module.exports = __webpack_public_path__ + "img/轮播4.94be3824.png";